import { render, staticRenderFns } from "./VocIcon.vue?vue&type=template&id=2205ae24&scoped=true&"
import script from "./VocIcon.vue?vue&type=script&lang=js&"
export * from "./VocIcon.vue?vue&type=script&lang=js&"
import style0 from "./VocIcon.vue?vue&type=style&index=0&id=2205ae24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2205ae24",
  null
  
)

export default component.exports